import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ServerDownOverlay: React.FC = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onDown = () => setShow(true);
    window.addEventListener("app:server-down", onDown);
    return () => window.removeEventListener("app:server-down", onDown);
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(10,14,26,.97)",
        backdropFilter: "blur(6px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        padding: 24,
        textAlign: "center",
      }}>
      <style>{`
        @keyframes puppyWiggle {
          0%, 100% { transform: rotate(-4deg); }
          50% { transform: rotate(4deg); }
        }
        @keyframes cableSpark {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: .4; transform: scale(.85); }
        }
        .puppy-wiggle { animation: puppyWiggle 1.4s ease-in-out infinite; display: inline-block; }
        .cable-spark { animation: cableSpark 0.8s ease-in-out infinite; display: inline-block; }
      `}</style>

      <div style={{ fontSize: 64, lineHeight: 1 }}>
        <span className="puppy-wiggle">🐶</span>
        <span className="cable-spark" style={{ marginLeft: -6 }}>
          🔌
        </span>
        <span className="cable-spark" style={{ marginLeft: 2 }}>
          ⚡
        </span>
      </div>

      <p style={{ color: "#fff", fontWeight: 800, fontSize: 18 }}>
        Voy! Kuchukcha tokni tishlab qo'ydi 🐾
      </p>
      <p
        style={{
          color: "#94a3b8",
          fontSize: 13,
          maxWidth: 340,
          lineHeight: 1.5,
        }}>
        Server bilan bog'lanib bo'lmadi. Bir necha daqiqadan so'ng qayta
        urinib ko'ring. Muammo davom etsa — Adminga murojaat qiling.
      </p>

      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: "none",
            background: "#3b82f6",
            color: "#fff",
            fontWeight: 700,
            fontSize: 13,
            cursor: "pointer",
          }}>
          Qayta urinish
        </button>
        <button
          onClick={() => {
            setShow(false);
            navigate("/contacts");
          }}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: "1px solid #1e2d45",
            background: "transparent",
            color: "#e2e8f0",
            fontWeight: 700,
            fontSize: 13,
            cursor: "pointer",
          }}>
          Adminga murojaat qilish
        </button>
      </div>
    </div>
  );
};

export default ServerDownOverlay;
